import { Heart } from "lucide-react";

export const Marquee = ({ items }) => (
  <div
    className="overflow-hidden border-y border-line bg-cream py-4"
    data-testid="editorial-marquee"
  >
    <div className="animate-marquee flex w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {items.map((text, i) => (
            <span
              key={i}
              className="flex items-center font-serif text-lg italic text-cocoa"
            >
              <span className="px-7">{text}</span>
              <Heart className="h-3.5 w-3.5 text-gold" fill="currentColor" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
